import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './App.css';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// COMPONENTS

import Header 			from './components/header';
import Footer 			from './components/footer';
import SearchEngine 	from './components/search-engine';


// VIEWS

import Home 			from './views/home';
import Login 			from './views/login';
import Logout 			from './views/logout';
import Profile 			from './views/profile';
import Product			from './views/product';
import Service			from './views/service';
import Property 		from './views/property';
import Products 		from './views/products';
import Services 		from './views/services';
import Properties 		from './views/properties';
import Foods 			from './views/foods';
import Customers 	 	from './views/customers';
import Search 		 	from './views/search';
import Conversation  	from './views/conversation';
import Conversations 	from './views/conversations';
import Cart 			from './views/cart';
import Checkout 		from './views/checkout';
import Register 		from './views/register';
import PrivacyPolicy 	from './views/privacy-policy';
import ShippingPolicy 	from './views/shipping-policy';
import ReturnPolicy 	from './views/return-policy';
import Admin 			from './views/admin';

export default function App() {

	return (
			<Router>
				<Header />
				<SearchEngine />

				<Routes>
					<Route exact path="/" 						element={<Home />} 				/>
					<Route path="/admin" 						element={<Admin />} 			/>
					<Route path="/profile" 						element={<Profile />} 			/>
					<Route path="/profile/products" 			element={<Profile />} 			/>
					<Route path="/profile/properties" 			element={<Profile />} 			/>
					<Route path="/profile/services" 			element={<Services />} 			/>
					<Route path="/profile/customers" 			element={<Customers />} 		/>
					<Route path="/product/:productId" 			element={<Product />} 			/>
					<Route path="/service/:serviceId" 			element={<Service />} 			/>
					<Route path="/property/:propertyId" 		element={<Property />} 			/>
					<Route path="/products" 					element={<Products />} 			/>
					<Route path="/services" 					element={<Services />} 			/>
					<Route path="/properties" 					element={<Properties />} 		/>
					<Route path="/foods" 						element={<Foods />} 			/>
					<Route path="/logout" 						element={<Logout />} 			/>
					<Route path="/login" 						element={<Login />} 			/>
					<Route path="/register" 					element={<Register />} 			/>
					<Route path="/conversation/:conversationId" element={<Conversation />} 		/>
					<Route path="/conversations" 				element={<Conversations />} 	/>
					<Route path="/cart" 						element={<Cart />} 				/>
					<Route path="/checkout" 					element={<Checkout />} 			/>
					<Route path="/search" 						element={<Search />} 			/>
					<Route path="/privacy-policy" 				element={<PrivacyPolicy />} 	/>
					<Route path="/shipping-policy" 				element={<ShippingPolicy />} 	/>
					<Route path="/return-policy" 				element={<ReturnPolicy />} 		/>
					<Route path="*" 							element={<Home />} 				/>
				</Routes>

				<Footer />
			</Router>
	);
};